import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
export function GuaranteeSection() {
  return <section className="w-full bg-cream-100 px-6 py-10 sm:py-12" aria-labelledby="guarantee-title" data-id="element-85" data-mp="4vjmq3szb4em">
      <div className="mx-auto max-w-2xl text-center" data-id="element-86" data-mp="9t1ptdkbepep">
        <SectionHeading id="guarantee-title" badge="Your investment is 100% protected" badgeIcon={ShieldCheckIcon} title="7-Day “Surgical Conscience” Guarantee" data-id="element-87" data-mp="etpmofv860gu" />

        <div className="mt-5 rounded-2xl border border-cream-300/70 bg-cream-50 p-6" data-id="element-88" data-mp="nt2p4okxlos2">
          <p className="text-base leading-relaxed text-forest-700/90" data-id="element-89" data-mp="skkppbj1lnci">
            Try the system for 7 days. If you don’t feel it saves you hours of work and elevates your
            teaching level, we will refund your money. No questions asked.
          </p>
          <p className="mt-4 inline-block rounded-full bg-cream-100 px-4 py-2 text-sm font-semibold text-forest-700" data-id="element-90" data-mp="12h7bc2j70ifl">
            Zero risk
          </p>
        </div>
      </div>
    </section>;
}